import { Logger } from 'services';

export const trackingGroupDeleteRequest = (operation: any) => {
  Logger.log('trackingGroupDeleteRequest');
};

export const trackingGroupDeleteResponse = (operation: any) => {
  Logger.log('trackingGroupDeleteResponse');
};
